import Masonry from 'masonry-layout';
var imagesLoaded = require('imagesloaded');

import Cocoen from './cocoen-fork/cocoen';

$(() => {
  var masonryGrid = $(".masonry-grid");
  if(masonryGrid.length == 0) return;

  $(masonryGrid).each((i, grid) => {
    imagesLoaded(grid, function() {
      var cocoens = [];
      $(grid).find(".cocoen.cocoen-lazy").each((i, el) => {
        cocoens.push(new Cocoen(el));
      });
      var msnry = new Masonry(grid, {
        columnWidth: '.masonry-grid-sizer',
        itemSelector: '.masonry-grid-item',
        percentPosition: true,
        gutter: 15,
        initLayout: false,
      });
      msnry.on('layoutComplete', () => {
        for(var cocoen of cocoens) {
          cocoen.dimensions();
        }
      });
      if($(grid).is(":visible")) {
        msnry.layout();
      }

      var gridId = $(grid).attr("id");
      $(`a[data-toggle="tab"][href="#${gridId}"]`).on('shown.bs.tab', (e) => {
        msnry.layout();
      });
    })
  });
});
